import { RouteRecordRaw } from "vue-router";

export const training: RouteRecordRaw = {
  path: "/training",
  component: () => import(/* webpackChunkName: "ad" */ "@/layouts/Default.vue"),
  children: [
    {
      path: "detail/:trainingId",
      name: "TrainingDetail",
      component: () =>
        import(/* webpackChunkName: "ad" */ "@/views/training/Detail.vue"),
      meta: {
        isBeforeLogin: false
      }
    },
    {
      path: "preview",
      name: "TrainingPreview",
      component: () =>
        import(/* webpackChunkName: "ad" */ "@/views/training/Preview.vue"),
      meta: {
        isBeforeLogin: true
      }
    }
  ]
};
